import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, nextProject }) =>
    present(
      repository
        .updateProject(project, nextProject)
        .catch(() => Promise.reject({ project, nextProject })),
    );
}

export type { Interactor };

export { createInteractor };
